import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { class_type, bool_type, int32_type, union_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { IsoCountryCode$reflection } from "../../DomainTypes.js";
import { fromString, list, string, int, object } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ofArray, map } from "../../fable_modules/fable-library.3.7.20/List.js";

export class Country extends Record {
    constructor(DisplayName, Code) {
        super();
        this.DisplayName = DisplayName;
        this.Code = Code;
    }
}

export function Country$reflection() {
    return record_type("Containers.CustomerContract.Common.Country", [], Country, () => [["DisplayName", string_type], ["Code", IsoCountryCode$reflection()]]);
}

export class BatchType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StandardInvoice", "PaymentInvoice", "DirectInvoice", "Unknown"];
    }
}

export function BatchType$reflection() {
    return union_type("Containers.CustomerContract.Common.BatchType", [], BatchType, () => [[], [], [], []]);
}

export function BatchType_get_ofInt() {
    return (_arg) => ((_arg === 0) ? (new BatchType(0)) : ((_arg === 1) ? (new BatchType(1)) : ((_arg === 2) ? (new BatchType(2)) : (new BatchType(3)))));
}

export function BatchType_toTranslation_11D407F6(getTranslation) {
    return (_arg) => ((_arg.tag === 1) ? getTranslation("CustomerContract.Invoicee.InvoiceeBatch.PaymentInvoice") : ((_arg.tag === 2) ? getTranslation("CustomerContract.Invoicee.InvoiceeBatch.DirectInvoice") : ((_arg.tag === 3) ? getTranslation("Common.Unknown") : getTranslation("CustomerContract.Invoicee.InvoiceeBatch.StandardInvoice"))));
}

export class InvoiceeBatch extends Record {
    constructor(InvoiceeBatchId, InvoiceeBatchName, BatchType) {
        super();
        this.InvoiceeBatchId = (InvoiceeBatchId | 0);
        this.InvoiceeBatchName = InvoiceeBatchName;
        this.BatchType = BatchType;
    }
}

export function InvoiceeBatch$reflection() {
    return record_type("Containers.CustomerContract.Common.InvoiceeBatch", [], InvoiceeBatch, () => [["InvoiceeBatchId", int32_type], ["InvoiceeBatchName", string_type], ["BatchType", BatchType$reflection()]]);
}

export function InvoiceeBatch_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new InvoiceeBatch((objectArg = get$.Required, objectArg.Field("InvoiceeBatchId", uncurry(2, int))), (objectArg_1 = get$.Required, objectArg_1.Field("InvoiceeBatchName", string)), BatchType_get_ofInt()((objectArg_2 = get$.Required, objectArg_2.Field("BatchType", uncurry(2, int)))));
    }, path_1, v));
}

export function InvoiceeBatch_get_ListDecoder() {
    const decoder = InvoiceeBatch_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export function InvoiceeBatch_get_DecodeFromString() {
    const decoder = InvoiceeBatch_get_ListDecoder();
    return (value) => fromString(uncurry(2, decoder), value);
}

export class CreditCheckDTO extends Record {
    constructor(address, allowed_contracts, approved, date, full_name, postal_city, postal_code, scoring) {
        super();
        this.address = address;
        this.allowed_contracts = (allowed_contracts | 0);
        this.approved = approved;
        this.date = date;
        this.full_name = full_name;
        this.postal_city = postal_city;
        this.postal_code = postal_code;
        this.scoring = scoring;
    }
}

export function CreditCheckDTO$reflection() {
    return record_type("Containers.CustomerContract.Common.CreditCheckDTO", [], CreditCheckDTO, () => [["address", string_type], ["allowed_contracts", int32_type], ["approved", bool_type], ["date", class_type("System.DateTime")], ["full_name", string_type], ["postal_city", string_type], ["postal_code", string_type], ["scoring", string_type]]);
}

export function countryOptions(countries) {
    return map((country) => [country.Code.ThreeLetter, country.DisplayName], countries);
}

export function boolToString(boolValue) {
    if (boolValue) {
        return "true";
    }
    else {
        return "false";
    }
}

export function boolToLanguageString(getTranslation, _arg) {
    if (_arg) {
        return getTranslation("Common.Yes");
    }
    else {
        return getTranslation("Common.No");
    }
}

export function getTrueFalseOptions(getTranslation) {
    return ofArray([["true", getTranslation("Common.Yes")], ["false", getTranslation("Common.No")]]);
}

export function omniChannelDistribution(getTranslation, _arg) {
    if (_arg) {
        return getTranslation("CustomerContract.Invoicee.OmniChannelViaFenix");
    }
    else {
        return getTranslation("CustomerContract.Invoicee.OmniChannel");
    }
}

export function getOmniChannelDistributionOptions(getTranslation) {
    return ofArray([["true", getTranslation("CustomerContract.Invoicee.OmniChannelViaFenix")], ["false", getTranslation("CustomerContract.Invoicee.OmniChannel")]]);
}

